import React from 'react';
import { PermissionGuard } from 'src/guards/permission-guard';

/**
 * Higher-Order Component for Permission-based Route Protection
 * 
 * This HOC wraps a component with permission checking functionality.
 * It's useful for protecting entire routes or page components.
 * 
 * @param {React.ComponentType} WrappedComponent - The component to wrap
 * @param {string[]} permissions - Array of required permissions
 * @param {string} [message] - Custom message for permission denied
 * 
 * @returns {React.ComponentType} Enhanced component with permission checking
 * 
 * @example
 * const ProtectedOrganizationDetail = withPermission(
 *   OrganizationDetail, 
 *   ['organizations-read']
 * );
 */
export const withPermission = (WrappedComponent, permissions, message) => {
  const WithPermissionComponent = (props) => {
    return (
      <PermissionGuard permissions={permissions}
message={message}>
        <WrappedComponent {...props} />
      </PermissionGuard>
    );
  };

  WithPermissionComponent.displayName = `withPermission(${WrappedComponent.displayName || WrappedComponent.name})`;

  return WithPermissionComponent;
};